import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/nurse/groups",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getClass({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/${options.id}?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    saveAttendance({ dispatch, state, rootState }, data) {
      const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save-attendance`,
          method: isFormData ? "VID" : "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
